// utils/pastelThemes.js
export const pastelThemes = {
    purple: {
        primary: '#C8B6F6',
        'primary-light': '#E8DFFC',
        'primary-dark': '#A794E8',
        'primary-gradient': 'linear-gradient(135deg, #C8B6F6, #E8DFFC)',
        'bg-color': '#FAF8FF',
        'card-bg': '#FFFFFF',
        'card-border': '#E8DFFC',
        'text-primary': '#333333',
        'text-secondary': '#666666',
        'accent': '#C8B6F6',
        'accent-light': '#E8DFFC',
        'accent-dark': '#A794E8'
    },
    pink: {
        primary: '#FFB6D9',
        'primary-light': '#FFE0F0',
        'primary-dark': '#FF94C8',
        'primary-gradient': 'linear-gradient(135deg, #FFB6D9, #FFE0F0)',
        'bg-color': '#FFF8FC',
        'card-bg': '#FFFFFF',
        'card-border': '#FFE0F0',
        'text-primary': '#333333',
        'text-secondary': '#666666',
        'accent': '#FFB6D9',
        'accent-light': '#FFE0F0',
        'accent-dark': '#FF94C8'
    },
    lightblue: {
        primary: '#87CEEB',
        'primary-light': '#E0F4FF',
        'primary-dark': '#6BB6D6',
        'primary-gradient': 'linear-gradient(135deg, #87CEEB, #E0F4FF)',
        'bg-color': '#F0F8FF',
        'card-bg': '#FFFFFF',
        'card-border': '#E0F4FF',
        'text-primary': '#333333',
        'text-secondary': '#666666',
        'accent': '#87CEEB',
        'accent-light': '#E0F4FF',
        'accent-dark': '#6BB6D6'
    },
    lightgreen: {
        primary: '#98D8AA',
        'primary-light': '#E8F5E9',
        'primary-dark': '#7BC995',
        'primary-gradient': 'linear-gradient(135deg, #98D8AA, #E8F5E9)',
        'bg-color': '#F5FFF8',
        'card-bg': '#FFFFFF',
        'card-border': '#E8F5E9',
        'text-primary': '#333333',
        'text-secondary': '#666666',
        'accent': '#98D8AA',
        'accent-light': '#E8F5E9',
        'accent-dark': '#7BC995'
    }
};

// 테마별 추가 설정
export const themeConfig = {
    purple: {
        name: '라벤더',
        emoji: '🔮',
        description: '부드럽고 몽환적인 분위기'
    },
    pink: {
        name: '체리블라썸',
        emoji: '🌸',
        description: '따뜻하고 사랑스러운 분위기'
    },
    lightblue: {
        name: '스카이',
        emoji: '☁️',
        description: '맑고 시원한 분위기'
    },
    lightgreen: {
        name: '민트',
        emoji: '🌿',
        description: '상쾌하고 활기찬 분위기'
    }
};